exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".counter{display:flex;align-items:center}.counter.disabled .value{color:rgba(0,0,0,.26)}.counter .value{font-family:Avenir-Heavy;font-size:19.2px;line-height:31.1px;letter-spacing:0;margin:0 1rem}.counter .v-btn .v-btn__content .v-icon{font-size:14px}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};